<div class="slider-container">
    <figure class="testimonial" *ngFor="let testimonial of testimonials; let i = index"
        [ngClass]="{'active': i === currentSlide}">
        <blockquote>
            <p>{{ testimonial.quote }}</p>
        </blockquote>
        <figcaption>
            <div>
                <div>{{ testimonial.name }}, {{ testimonial.title }}</div>
            </div>
        </figcaption>
    </figure>
    <!-- Navigation controls -->
    <div class="controls">
        <button type="button" title="Vorige quote" (click)="prevSlide()">
            <mat-icon class="material-icons">chevron_left</mat-icon>
        </button>
        <button type="button" title="Volgende quote" (click)="nextSlide()">
            <mat-icon class="material-icons">chevron_right</mat-icon>
        </button>
    </div>
</div>